import { apiBaseUrl } from '../config/api_config';

let validPhoneConfigs = [];
let configsLoaded = false;

export const loadPhoneConfigs = async () => {
  try {
    const response = await fetch(`${apiBaseUrl}/haseela_system_admin/valid-phone-numbers/`);
    if (!response.ok) throw new Error('Failed to fetch phone configurations');
    const data = await response.json();
    validPhoneConfigs = Array.isArray(data) ? data : [];
    configsLoaded = true;
    return validPhoneConfigs;
  } catch (error) {
    console.error('Error loading phone configurations:', error);
    validPhoneConfigs = [
      { phone_prefix: '+972', phone_suffix_len: '9', country: 'Palestine' },
      { phone_prefix: '+970', phone_suffix_len: '9', country: 'Palestine' },
    ];
    configsLoaded = true;
    return validPhoneConfigs;
  }
};

export const getPhonePrefixes = async () => {
  if (!configsLoaded) await loadPhoneConfigs();
  return validPhoneConfigs.map((config) => ({
    prefix: config.phone_prefix,
    country: config.country,
    length: parseInt(config.phone_suffix_len, 10),
  }));
};
